import type { SVGAttributes } from 'react';

export function ShareXIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect width="24" height="24" rx="4" fill="white" />
			<path
				d="M15.8046 6H17.8415L13.3691 11.0923L18.5942 18H14.4939L11.2835 13.8022L7.60825 18H5.57135L10.3094 12.5535L5.30566 6H9.50788L12.4082 9.83469L15.8046 6ZM15.0916 16.8044H16.2208L8.91452 7.15129H7.70124L15.0916 16.8044Z"
				fill="currentColor"
			/>
		</svg>
	);
}
